export default function AdmissionsIcon({ width = 16, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='currentColor'
        d='M8 1.333A4.667 4.667 0 0 0 3.333 6C3.333 9.5 8 14.667 8 14.667S12.667 9.5 12.667 6A4.667 4.667 0 0 0 8 1.333Zm0 6.334A1.667 1.667 0 1 1 8 4.333a1.667 1.667 0 0 1 0 3.334Z'
      />
    </svg>
  );
}
